import {constants} from '@neosvoc/nv-platform-core-common';

export function lightenHex(hex, whiteAmount = 0.3) {
    const clean = hex.replace(/^#/, '');
    const full = clean.length === 3 ?
        clean.split('').map((c) => c + c).join('') :
        clean;

    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);

    const mix = (channel) => Math.round(channel * (1 - whiteAmount) + 255 * whiteAmount);

    return (
        '#' +
        [mix(r), mix(g), mix(b)]
            .map((v) => v.toString(16).padStart(2, '0'))
            .join('')
    );
}

export function darkenHex(hex, blackAmount = 0.3) {
    const clean = hex.replace(/^#/, '');
    const full = clean.length === 3 ?
        clean.split('').map((c) => c + c).join('') :
        clean;

    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);

    const mix = (channel) => Math.round(channel * (1 - blackAmount));

    return (
        '#' +
        [mix(r), mix(g), mix(b)]
            .map((v) => v.toString(16).padStart(2, '0'))
            .join('')
    );
}
const getGoogleUrl = (fontName) => `https://fonts.googleapis.com/css?family=${encodeURIComponent(fontName)}:400,700`;
export function getEmbedCodeForFont(font) {
    switch (font) {
        case constants.BRANDING_FONTS.ROBOTO:
            return `@import url('${getGoogleUrl('Roboto')}');`;
        case constants.BRANDING_FONTS.OPEN_SANS:
            return `@import url('${getGoogleUrl('Open Sans')}');`;
        case constants.BRANDING_FONTS.OSWALD:
            return `@import url('${getGoogleUrl('Oswald')}');`;
        case constants.BRANDING_FONTS.LORA:
            return `@import url('${getGoogleUrl('Lora')}');`;
        case constants.BRANDING_FONTS.LOBSTER_TWO:
            return `@import url('${getGoogleUrl('Lobster Two')}');`;
        case constants.BRANDING_FONTS.KALAM:
            return `@import url('${getGoogleUrl('Kalam')}');`;
        case constants.BRANDING_FONTS.ALBERT:
            return `@import url('${getGoogleUrl('Albert')}');`;
        default:
            return `@import url('${getGoogleUrl('Work Sans')}');`;
    }
}

export function getCssValueForFontFamily(font) {
    switch (font) {
        case constants.BRANDING_FONTS.ROBOTO:
            return "'Roboto', sans-serif";
        case constants.BRANDING_FONTS.OPEN_SANS:
            return "'Open Sans', sans-serif";
        case constants.BRANDING_FONTS.OSWALD:
            return "'Oswald', sans-serif";
        case constants.BRANDING_FONTS.LORA:
            return "'Lora', sans-serif";
        case constants.BRANDING_FONTS.LOBSTER_TWO:
            return "'Lobster Two', sans-serif";
        case constants.BRANDING_FONTS.KALAM:
            return "'Kalam', sans-serif";
        case constants.BRANDING_FONTS.ALBERT:
            return "'Albert', sans-serif";
        default:
            return "'Work Sans', sans-serif";
    }
}

export function getButtonsStyle(uiBranding = {}) {
    const buttonsBranding = uiBranding.buttons ? uiBranding.buttons : {};
    const defaultButtonsBranding = {
        backgroundColor: '#119BD6',
        borderColor: '#119BD6',
        color: '#fff',
    };
    return {
        backgroundColor: buttonsBranding.backgroundColor || defaultButtonsBranding.backgroundColor,
        backgroundHoverColor: buttonsBranding.backgroundHoverColor || darkenHex(buttonsBranding.backgroundColor || defaultButtonsBranding.backgroundColor, 0.5),
        textColor: buttonsBranding.textColor || defaultButtonsBranding.color,
        textHoverColor: buttonsBranding.textHoverColor || defaultButtonsBranding.color,
        font: buttonsBranding.font || constants.BRANDING_FONTS.WORK_SANS,
        fontSize: buttonsBranding.fontSize || 14,
        paddingVertical: buttonsBranding.padding || 6,
        paddingHorizontal: buttonsBranding.paddingHorizontal || 12,
        borderColor: buttonsBranding.borderColor || defaultButtonsBranding.borderColor,
        borderHoverColor: buttonsBranding.borderHoverColor || darkenHex(buttonsBranding.borderColor || defaultButtonsBranding.borderColor, 0.5),
        borderWidth: buttonsBranding.borderWidth || 1,
        borderRadius: buttonsBranding.borderRadius || 4,
    };
}
